export enum AbhaHeroModalStep {
  Loading = 'loading',
  Aadhaar = 'aadhaar',
  Otp = 'otp',
  Prepare = 'prepare',
  Success = 'success',
  Error = 'error',
}

export enum AbhaJourneyNodeId {
  AadhaarInputV2 = 'abha_aadhaar_input_v2',
  OtpVerificationV2 = 'abha_otp_verification_v2',
  ResendOtpV2 = 'abha_resend_otp_v2',
  MobileLinkingV2 = 'abha_mobile_linking_v2',
  MobileOtpVerificationV2 = 'abha_mobile_otp_verification_v2',
  MobileSearchV2 = 'abha_mobile_search_v2',
  MobileAccountSelectionV2 = 'abha_mobile_account_selection_v2',
  MobileLoginOtpVerificationV2 = 'abha_mobile_login_otp_verification_v2',
  ResendMobileLoginOtpV2 = 'abha_resend_mobile_login_otp_v2',
  CreationV2 = 'abha_creation_v2',
  OtpInvalid = 'abha_otp_invalid',
  AlreadyExists = 'abha_already_exists',
}
